import { useState, type FormEvent } from 'react';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);
    const honeypot = formData.get('phone_alt') as string;
    if (honeypot && honeypot.trim().length > 0) {
      setStatus('success');
      setMessage('订阅成功！感谢你的关注。');
      setEmail('');
      return;
    }
    formData.delete('phone_alt');
    try {
      const res = await fetch('https://readdy.ai/api/form/d9slr1llbrt1qcgaj5qg', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }
      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setMessage('订阅成功！感谢你的关注，我们会定期为你推送优质内容。');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '';
        if (serverMsg.includes('spam')) {
          setStatus('error');
          setMessage('提交失败，请稍后重试。');
        } else {
          setStatus('error');
          setMessage(serverMsg || '订阅失败，请稍后重试。');
        }
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查网络后重试。');
    }
  };

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-accent-50">
      <div className="max-w-2xl mx-auto text-center">
        <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-500 mx-auto mb-4">
          <i className="ri-mail-send-line text-2xl w-7 h-7 flex items-center justify-center"></i>
        </div>
        <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">
          订阅蜜桃周刊
        </h2>
        <p className="text-sm text-foreground-600 mb-6 md:mb-8">
          每周精选优质内容，直达你的邮箱。不错过每一份甜蜜与美好。
        </p>

        <form
          data-readdy-form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
        >
          <div className="honeypot-wrap">
            <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
          </div>
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 px-4 py-3 rounded-full border border-background-300 text-sm bg-background-50 focus:outline-none focus:border-accent-400 focus:ring-2 focus:ring-accent-200 transition-all"
          />
          <button
            type="submit"
            className="bg-accent-500 text-background-50 px-6 py-3 rounded-full text-sm font-medium hover:bg-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即订阅
          </button>
        </form>

        {status === 'success' && (
          <p className="mt-4 text-sm text-accent-600">{message}</p>
        )}
        {status === 'error' && (
          <p className="mt-4 text-sm text-red-500">{message}</p>
        )}
      </div>
    </section>
  );
}